<script>
import options from './DonationCard.options'
export default options
</script>

<template>
  <article class="kb-donation-card" :class="modifierClass">
    <section class="kb-donation-card__donation-container">
      <p class="kb-donation-card__donation-amount">{{ result.amount }} kr</p>
      <template v-if="result.note">
        <p class="kb-donation-card__donation-note">{{ result.note }}</p>
      </template>
    </section>
    <section class="kb-donation-card__donator">
      <h3 class="kb-donation-card__donator__name">{{ result.name }}</h3>
      <p class="kb-donation-card__donator__quote">{{ result.quote }}</p>
    </section>
  </article>
</template>
